import React, { useEffect } from "react";

const SlidingVideosCart = ({ item, openImage }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="max-w-full w-[290px] h-full my-10 bg-slate-50 rounded-xl  shadow-lg shadow-gray-300  p-2">
        <div className="max-w-full h-full">
          <iframe
            className="w-full h-full  rounded-xl "
            src={item.url}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <p className="py-2 text-black">{item.title}</p>
      </div>
    </div>
  );
};

export default SlidingVideosCart;
